import React from 'react';
import { NoSuggestionsBody } from '../NoSuggestionsBody';
import { RecentSearchBody } from '../RecentSearchBody';
import { SearchDefaultBody } from '../SearchDefaultBody';
import { SearchLoading } from '../SearchLoading';
import { SearchQuerySuggestionsBody } from '../SearchQuerySuggestionsBody';
export let BODY_STATES = /*#__PURE__*/function (BODY_STATES) {
  BODY_STATES[BODY_STATES["LOADING"] = 0] = "LOADING";
  BODY_STATES[BODY_STATES["SEARCH_RESULTS"] = 1] = "SEARCH_RESULTS";
  BODY_STATES[BODY_STATES["RECENT_SEARCHES"] = 2] = "RECENT_SEARCHES";
  BODY_STATES[BODY_STATES["EMPTY_STATE"] = 3] = "EMPTY_STATE";
  BODY_STATES[BODY_STATES["API_FAILURE"] = 4] = "API_FAILURE";
  BODY_STATES[BODY_STATES["NO_SUGGESTIONS"] = 5] = "NO_SUGGESTIONS";
  BODY_STATES[BODY_STATES["NO_BODY"] = 6] = "NO_BODY";
  return BODY_STATES;
}({});
export function SearchBodyFactory(_ref) {
  let {
    type,
    searchQuerySuggestionsBodyProps,
    searchLoadingProps,
    recentSearchBodyProps,
    noSuggestionsBodyProps
  } = _ref;
  switch (type) {
    case BODY_STATES.LOADING:
      return /*#__PURE__*/React.createElement(SearchLoading, searchLoadingProps);
    case BODY_STATES.SEARCH_RESULTS:
      return /*#__PURE__*/React.createElement(SearchQuerySuggestionsBody, searchQuerySuggestionsBodyProps);
    case BODY_STATES.RECENT_SEARCHES:
      return /*#__PURE__*/React.createElement(RecentSearchBody, recentSearchBodyProps);
    case BODY_STATES.EMPTY_STATE:
      return /*#__PURE__*/React.createElement(SearchDefaultBody, null);
    case BODY_STATES.NO_SUGGESTIONS:
    case BODY_STATES.API_FAILURE:
      return /*#__PURE__*/React.createElement(NoSuggestionsBody, noSuggestionsBodyProps);
    case BODY_STATES.NO_BODY:
    default:
      return null;
  }
}